<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
   viewBox="0 0 300 300" style="enable-background:new 0 0 300 300;" xml:space="preserve">
<path class="white" d="M293.8,165.1L165.1,293.8c-8.3,8.3-21.8,8.3-30.1,0L6.2,165.1c-8.3-8.3-8.3-21.8,0-30.1
  L134.9,6.2c8.3-8.3,21.8-8.3,30.1,0l128.7,128.7C302.1,143.3,302.1,156.7,293.8,165.1z"/>
<g>
  <path class="blue" d="M46.9,192.2l45.1-45.2c7.2-7.2,5.8-7.1,13.1,0.1l47.6,47.4c6.1,6,5.1,7.5,11.2,1.4l16-16.1
    l16-16.1c6.1-6.1,4.7-5.2-1.4-11.2L146.9,105c-7.2-7.2-7.4-5.8-0.2-13.1l45.1-45.2L159,14.1c-5.1-5.1-13.4-5.1-18.5,0L98.2,56.5
    l-20.9,21l-20.9,21L14,141c-5.1,5.1-5,13.4,0,18.5L46.9,192.2z"/>
  <path class="light" d="M146.7,92l45.1-45.2L159,14.1c-5.1-5.1-13.4-5.1-18.5,0l-16.9,17
    c-11.7,16.5-18.2,34.7-18.2,53.7c0.1,38.9,27.2,73.9,70.7,98.6l3.7-3.7l16-16.1c6.1-6.1,4.7-5.2-1.4-11.2L146.9,105
    C139.6,97.8,139.5,99.2,146.7,92L146.7,92z"/>
  <path class="green" d="M53.8,199.1l87.2,86.9c5.1,5.1,13.4,5,18.5,0l63.2-63.5l63.2-63.5c5.1-5.1,5.1-13.4,0-18.5
    l-87.2-86.9l-44.6,44.8l47.2,47.1c3.6,3.6,7.6,6.2,8.2,11.9c0.5,5.7-3.1,9.5-6.7,13.2l-32.1,32.2c-3.7,3.7-7.5,7.3-13.2,6.8
    c-5.7-0.5-8.3-4.5-11.9-8.1l-47.2-47.1L53.8,199.1z"/>
</g>
</svg>
